import BookIcon from '@material-ui/icons/Book'
import PointsEventEdit from './PointsEventEdit'
import PointsEventList from './PointsEventList'

export default {
  list: PointsEventList,
  edit: PointsEventEdit,
  icon: BookIcon,
}
